export function reqTypeRename(row) {
  const reqType = [
    { key: 1, value: "주문접수" },
    { key: 2, value: "주문수정" },
    { key: 3, value: "주문취소" }
  ];
  const findType = _.find(reqType, d => {
    return d.key === row;
  });
  let reqTypeName = "";
  if (findType === false || typeof findType === "undefined") {
    reqTypeName = reqType[0].value;
  } else {
    reqTypeName = findType.value;
  }
  return reqTypeName;
}

export function orderApplyStateRename(row) {
  const orderApplyStateType = [
    { key: -1, value: "실시간 적용 대상 아님" },
    { key: 0, value: "기본" },
    { key: 1, value: "성공" },
    { key: 2, value: "실패" }
  ];
  const findType = _.find(orderApplyStateType, d => {
    return d.key === row;
  });
  let orderApply = "";
  if (findType === false || typeof findType === "undefined") {
    orderApply = orderApplyStateType[0].value;
  } else {
    orderApply = findType.value;
  }
  return orderApply;
}

export function billingStateToName(value) {
  switch (value) {
    case "BS00":
      return "요청전";
    case "BS01":
      return "요청";
    case "BS02":
      return "확정";
    case "BS03":
      return "마감";
    case "BS04":
      return "반송";
    case "BS99":
      return "청구제외";
    default:
      return "알 수 없음";
  }
}

export function standbyCodeToName(value) {
  switch (value) {
    case "1301":
      return "(대기)차량부재";
    case "1302":
      return "(대기)운행불가";
    case "1303":
      return "(대기)정비출고지연";
    case "1304":
      return "(대기)고객요청";
    case "1305":
      return "(대기)고객정보오류";
    case "1399":
      return "(대기)기타";
    case "1599":
      return "(기타)사유내용기제";
    default:
      return "-";
  }
}
// 대기,기타사유코드
// 1301 : (대기)차량부재
// 1302 : (대기)운행불가
// 1303 : (대기)정비출고지연
// 1304 : (대기)고객요청
// 1305 : (대기)고객정보오류
// 1399 : (대기)기타
// 1599 : (기타)사유내용기제

export function orderStateToName(value) {
  switch (value) {
    case 10156:
      return "운행완료";
    case 10157:
      return "취소";
    case 10165:
      return "유상취소";
    default:
      return "알 수 없음";
  }
}

export function comma(val) {
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 10156 : 운행완료
// 10157 : 취소

// null:요청전(cs마감)
// BS01:요청
// BS02:확정
// BS03:마감
// BS04:반송



// WEBPACK FOOTER //
// ./src/utils/rocket-code.js